import { render, staticRenderFns } from "./IconSvgResources.vue?vue&type=template&id=766e5dda&scoped=true&"
import script from "./IconSvgResources.vue?vue&type=script&lang=js&"
export * from "./IconSvgResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e5dda",
  null
  
)

export default component.exports